import { render, staticRenderFns } from "./ArticleMetadata.vue?vue&type=template&id=2b3ed8d6&scoped=true"
import script from "./ArticleMetadata.vue?vue&type=script&lang=js"
export * from "./ArticleMetadata.vue?vue&type=script&lang=js"
import style0 from "./ArticleMetadata.vue?vue&type=style&index=0&id=2b3ed8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ed8d6",
  null
  
)

export default component.exports